// 仅投影平台固定枚举；品牌名、型号、批次、自填货况和具体地址保留原文。
const factKeys = Object.freeze({
  brand: { 白牌: "pcProduct.whiteLabel" },
  condition: {
    原厂原包: "pcProduct.originalFactoryPackaging",
    非原厂原包: "pcProduct.nonFactoryPackaging",
    原箱原封: "pcProduct.factorySealedBox",
    原箱已拆封: "pcProduct.factoryOpenedBox",
    自封颗粒: "contractFlow.selfPackagedChips",
    "原标（测试）": "contractFlow.testedOriginalMarking",
    非原标: "contractFlow.nonOriginalMarking",
    翻新: "contractFlow.refurbished",
    二手: "contractFlow.used",
    全新: "pcClue.brandNew",
    全新原装: "adminFlows.newAndOriginal",
    原装: "bidPage.conditionOriginalGoods",
    原厂: "bidPage.conditionOriginalFactory",
    原箱: "bidPage.conditionOriginalBox",
    原包: "bidPage.conditionOriginalPack",
    原标: "bidPage.conditionOriginalLabel",
    原封: "devUpdates.factorySealed",
    拆机: "adminFlows.salvaged",
    散新: "adminFlows.newLoosePackaging",
  },
  location: {
    中国香港: "bidPage.locationHongKong",
    中国大陆: "bidPage.locationMainland",
    保税区: "bidPage.locationBonded",
  },
  unit: { 个: "pcProduct.unitPiece", 件: "pcProduct.unitItem", 箱: "pcProduct.unitBox", 套: "pcProduct.unitSet" },
});

export function productFactText(value, field, translate) {
  const display = raw => {
    const text = String(raw ?? "");
    const keys = factKeys[field];
    return keys && Object.hasOwn(keys, text.trim()) ? translate(keys[text.trim()]) : text;
  };
  if (field !== "condition") return display(value);
  let conditions = value;
  if (typeof conditions === "string") {
    try {
      const parsed = JSON.parse(conditions);
      if (Array.isArray(parsed)) conditions = parsed;
    } catch (_) { /* 旧接口亦可能直接返回逗号分隔的货况。 */ }
  }
  const items = Array.isArray(conditions) ? conditions : String(conditions ?? "").split(/[,，、;；]/u);
  return items.map(display).join(translate("pcProduct.conditionSeparator"));
}

export function productQuantityText(count, unit, translate) {
  return unit ? translate("pcProduct.quantityWithUnit", { count, unit: productFactText(unit, "unit", translate) }) : String(count ?? "");
}

export function productAttributeLabel(value, translate) {
  const keys = { 封装: "pcProduct.attributePackage", 重量: "pcProduct.weight", 颜色: "pcProduct.attributeColor" };
  return typeof value === "string" && Object.hasOwn(keys, value) ? translate(keys[value]) : value;
}

export function productAttributeValue(value, translate) {
  const raw = String(value ?? "");
  const colors = { 蓝色: "pcProduct.colorBlue", 红色: "pcProduct.colorRed", 黑色: "pcProduct.colorBlack", 白色: "pcProduct.colorWhite" };
  if (Object.hasOwn(colors, raw)) return translate(colors[raw]);
  // 仅处理完整的数值+标准单位，不改动型号、自填说明或数值本身。
  const weight = raw.match(/^([+-]?\d+(?:\.\d+)?)\s*(毫克|千克|公斤|克)$/u);
  if (weight) return translate("pcProduct.quantityWithUnit", { count: weight[1], unit: translate({ 毫克: "pcProduct.unitMilligram", 克: "sourcePublish.gram", 千克: "pcProduct.unitKilogram", 公斤: "pcProduct.unitKilogramColloquial" }[weight[2]]) });
  return raw;
}
